// extracted by css-extract-rspack-plugin
export default {"selectEditor":"wAqGV1W9li8dEdYE"};